import { ViewContainerRef } from '@angular/core';
import { ConfirmDialogService } from '@app/finxone-web-frontend/app/Modules/shared/components-library/confirmation-dilog/confirmation-dialog.service';

// Prompt user confirmation to prevent accidental file uploads
export function showUploadFileConfirmDialog(
  viewContainerRef: ViewContainerRef | null,
  confirmDialogService: ConfirmDialogService,
  fileName: string,
): Promise<boolean> {
  return confirmDialogService.confirm(viewContainerRef, {
    title: `${fileName}`,
    content: `Are you sure you want to upload this file?`,
    positiveText: 'Upload',
    negativeText: 'Cancel',
  });
}
